import type { UnresolvedVisualIdentity } from './document-types';

export interface HumanIdentityReview {
  id: string; requestId: string; snapshotId: string; orderId: string;
  documentId: string; storageDocumentId: string; documentVersionId: string; fileName: string;
  sourceIdentity: UnresolvedVisualIdentity; reviewedPage: number; confirmedName: string;
  reviewedBy: string; reviewedAt: string; revision: number; previousDecisionId: string | null;
  evidenceStatus: 'available' | 'unavailable' | 'not_recorded';
  screening: { status: 'approved' | 'flagged' | 'pending'; checkedAt: string;
    matches: Array<{ source: string; confidence: number; details: string }> };
  retainedScreening?: { decisionId: string; checkedAt: string; matches: Array<{ source: string; confidence: number; details: string }> };
}

export const screeningLabel = (review: HumanIdentityReview): string => review.screening.status === 'approved'
  ? 'No matches above the screening threshold'
  : review.screening.status === 'flagged' ? 'Potential sanctions matches — review required'
    : review.retainedScreening ? 'Screening incomplete — previous potential matches still require review' : 'Screening incomplete — retry required';

export function latestHumanReviews(history: HumanIdentityReview[]): HumanIdentityReview[] {
  const latest = new Map<string, HumanIdentityReview>();
  for (const review of history) {
    const key = JSON.stringify([review.documentId, review.sourceIdentity.occurrenceId]);
    if (!latest.has(key) || latest.get(key)!.revision < review.revision) latest.set(key, review);
  }
  return [...latest.values()].map(review => {
    if (review.screening.status !== 'pending') return review;
    const prior = history.filter(item => item.documentId === review.documentId && item.sourceIdentity.occurrenceId === review.sourceIdentity.occurrenceId
      && item.confirmedName === review.confirmedName && item.revision < review.revision && item.screening.status !== 'pending')
      .sort((a, b) => b.revision - a.revision)[0];
    return prior?.screening.status === 'flagged' ? { ...review, retainedScreening: {
      decisionId: prior.id, checkedAt: prior.screening.checkedAt, matches: prior.screening.matches,
    } } : review;
  });
}
